import React, { useEffect, useState } from "react";
import { Card, CardBody, Container, Row, Spinner } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Link } from "react-router-dom";
import { getSellerWithdrawals } from "../../../api/ecommerce";
import { toast, ToastContainer } from "react-toastify";
const WithDrawSeller = () => {
  const [withdrawdata, setWithdrawData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Withdrawals | TopCoinLand";
  }, []);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getSellerWithdrawals()
      .then((rows) => {
        if (!cancelled) setWithdrawData(Array.isArray(rows) ? rows : []);
      })
      .catch((err) => {
        if (!cancelled) {
          setWithdrawData([]);
          toast.error(err?.error || err?.message || "Failed to load withdrawal requests");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const formatAmount = (row) => {
    const c = row.currency || "GBP";
    const sym = c === "GBP" ? "£" : c === "EUR" ? "€" : `${c} `;
    return `${sym}${Number(row.amount || 0).toFixed(2)}`;
  };

  const statusBadge = (status) => {
    const s = (status || "pending").toLowerCase();
    const cls =
      s === "approved"
        ? "bg-success"
        : s === "rejected" || s === "cancelled"
          ? "bg-danger"
          : s === "processing"
            ? "bg-info"
            : "bg-warning";
    return (
      <span className={`badge ${cls}`}>{s}</span>
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Withdrawals" pageTitle="Seller" />
          <Row>
            <Card>
              <CardBody>
                <div className="listjs-table" id="customerList">
                  <Row className="align-items-center gy-3">
                    <div className="col-sm">
                      <h5 className="card-title mb-0">Withdrawals</h5>
                      <p className="text-muted mb-0 small">
                        Your payout requests. Submit a new request or open a row for details.
                      </p>
                    </div>
                    <div className="col-sm-auto">
                      <Link to="/vendor-withdraw-request" className="btn btn-info">
                        <i className="ri-add-circle-line align-bottom me-1" />
                        Add Withdraw
                      </Link>
                    </div>
                  </Row>

                  {loading ? (
                    <div className="text-center py-5">
                      <Spinner color="primary" /> Loading...
                    </div>
                  ) : (
                    <div className="table-responsive table-card mt-3 mb-1">
                      <table className="table align-middle table-nowrap" id="customerTable">
                        <thead className="table-light">
                          <tr>
                            <th>Id</th>
                            <th>Amount</th>
                            <th>Request date</th>
                            <th>Status</th>
                            <th>Operations</th>
                          </tr>
                        </thead>
                        <tbody>
                          {withdrawdata.length === 0 ? (
                            <tr>
                              <td colSpan={5} className="text-center text-muted py-4">
                                No withdrawal requests yet. Click &quot;Add Withdraw&quot; to create one.
                              </td>
                            </tr>
                          ) : (
                            withdrawdata.map((item) => (
                              <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>{formatAmount(item)}</td>
                                <td>
                                  {item.created_at
                                    ? new Date(item.created_at).toLocaleString()
                                    : "—"}
                                </td>
                                <td>{statusBadge(item.status)}</td>
                                <td>
                                  <Link
                                    to={`/vendor-withdraw-request/${item.id}`}
                                    className="btn btn-sm btn-soft-primary"
                                  >
                                    <i className="ri-eye-line me-1" />
                                    View
                                  </Link>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
      <ToastContainer position="top-right" autoClose={4000} />
    </React.Fragment>
  );
};

export default WithDrawSeller;
